//----- angular app configuration-----
angular.module('config', []);
angular.module('config')
  .constant('ENABLE_SOCIAL', {
    facebook: true,
    google: true,
    twitter: true
  })
  .constant('REQUIRE_ACCOUNT_VERIFICATION', false)
  .constant('STATUSES', [
    {
      id: '0',
      value: 'status-editing-not-ready',
      color: '#fff',
      background: '#d04444'
    },
    {
      id: '-3',
      value: 'status-ready-to-publish',
      color: '#333',
      background: '#f5f74c'
    },
    {
      id: '3',
      value: 'status-published',
      color: '#FFF',
      background: '#d49772'
    },
    {
      id: '17',
      value: 'status-top-four',
      color: '#FFF',
      background: '#b455a8'
    },
    {
      id: '18',
      value: 'status-hompage',
      color: '#fff',
      background: '#389864'
    },
    {
      id: '90',
      value: 'status-author-zone',
      color: '#FFF',
      background: '#fed442'
    },
    {
      id: '-2',
      value: 'status-discard',
      color: '#333',
      background: '#cbcbcb'
    },
    {
      id: '-1',
      value: 'status-archived',
      color: '#333',
      background: '#cbcbcb'
    }
  ])
  .constant('ARTICLE_STYLES', [
    {
      id: '3',
      value: 'Artykuł'
    },
    {
      id: '1',
      value: 'Wideo'
    }
  ])
  .constant('APPLICATION', 'iworis')
  .constant('DEFAULT_EDITION', 'mx')
  .constant('XSRF_COOKIE_NAME', '_csrfToken')
  .constant('I18N.MESSAGES', {
    "en": require('json!../../i18n/en.json'),
    "es": require('json!../../i18n/en.json'),
    "pl": require('json!../../i18n/pl.json'),
  })
  .constant('APP_IMG_URLS', {
    "base": 'https://d3h1htyejpzygs.cloudfront.net/media/',
    "200": 'https://d3h1htyejpzygs.cloudfront.net/media/',
    "NO_PHOTO_200": "https://d3h1htyejpzygs.cloudfront.net/media/not-found-iworis-1603084029701.png",
	})
	;
angular.module('config').config(['$provide', 'ENABLE_SOCIAL', function($provide, ENABLE_SOCIAL){
  var setting = {
    'facebook': {
      text: 'Facebook',
      icon: 'fa-facebook-square',
      login: '/login/facebook',
      connect: '/account/settings/facebook/'
    },
    'google': {
      text: 'Google',
      icon: 'fa-google-plus-square',
      login: '/login/google',
      connect: '/account/settings/google/'
    },
    'twitter': {
      text: 'Twitter',
      icon: 'fa-twitter-square',
      login: '/login/twitter',
      connect: '/account/settings/twitter/'
    }

  };
  var social = {};
  angular.forEach(ENABLE_SOCIAL, function(enable, key){
    if(enable){
      social[key] = setting[key];
    }
  });

  // programmatically set constant, 'SOCIAL', in config module
  $provide.constant('SOCIAL', social);
}]);



// WEBPACK FOOTER //
// ./client/src/app/config-into.js